/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./location.component";
import * as i2 from "@angular/router";
import * as i3 from "./location.service";
import * as i4 from "@nguniversal/express-engine/tokens";
var styles_LocationComponent = [];
var RenderType_LocationComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_LocationComponent, data: {} });
export { RenderType_LocationComponent as RenderType_LocationComponent };
export function View_LocationComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_LocationComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-location", [], null, null, null, View_LocationComponent_0, RenderType_LocationComponent)), i0.ɵdid(1, 114688, null, 0, i1.LocationComponent, [i2.Router, i3.Location, i0.PLATFORM_ID, [2, i4.REQUEST]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LocationComponentNgFactory = i0.ɵccf("fl-location", i1.LocationComponent, View_LocationComponent_Host_0, {}, {}, []);
export { LocationComponentNgFactory as LocationComponentNgFactory };
